module.exports = __webpack_public_path__ + "media/images/print-d8b734e552c3b8ca039e64ecb74e0c12.svg";